import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Cookies from 'js-cookie';
import Sidebar from './Sidebar';
import HomePage from './HomePage';
import PlayersComponent from './components/Players';
import Players2 from './components/Table';
import MatchHistory from './components/MatchHistory';
import MatchComponent from './components/Match';
import RoundFinderComponent from './components/RoundFinder';
import backgroundImage from './assets/background.jpg';
import './App.css'
import { fetchTeamIcons } from './components/data/TeamIcons';
import { fetchAgentIcons } from './components/data/AgentIcons';
import { fetchMaps } from './components/data/MapIcons';
import { fetchLeagueIcons } from './components/data/LeagueIcons';
import { fetchPlayerPhoto } from './components/data/PlayerPhoto';

function App() {
  const [loggedIn, setLoggedIn] = useState(Cookies.get('loggedIn') === 'true');
  const [s, forceUpdate] = useState(0);

  useEffect(() => {
    fetchPlayerPhoto().then(() => {
      forceUpdate((n) => n + 1);
    });
    fetchTeamIcons().then(() => {
      forceUpdate((n) => n + 1);
    });
    fetchAgentIcons().then(() => {
      forceUpdate((n) => n + 1);
    });
    fetchMaps().then(() => {
      forceUpdate((n) => n + 1);
    });
    fetchLeagueIcons().then(() => {
      forceUpdate((n) => n + 1);
    });
  }, []);

  return (
    <Router>
      <AppContent loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
    </Router>
  );
}

function AppContent({ loggedIn, setLoggedIn }) {
  const [sidebarVisible, setSidebarVisible] = useState(true);


  const toggleSidebar = () => setSidebarVisible(prev => !prev);
  return (
    <div className="app-container">
      {sidebarVisible && <Sidebar loggedIn={loggedIn} />}
      <div className="content" style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)), url(${backgroundImage})`, marginLeft: sidebarVisible ? "200px" : "0", backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'
      }}>
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/matchhistory" element={<MatchHistory />} />
          <Route exact path="/match/:gameId" element={<MatchComponent />} />
          <Route exact path="/players" element={<Players2 />} />
          <Route exact path="/roundFinder" element={<RoundFinderComponent />} />


        </Routes>
        {/*<Footbar loggedIn={loggedIn} />*/}
      </div>
    </div>

  );
}

export default App
